import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Change password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const changePasswordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.parent || !control) {
    return null;
  }

  const password = control.parent.get('newPassword');
  const passwordConfirm = control.parent.get('confirmPassword');

  if (!password || !passwordConfirm) {
    return null;
  }

  if (passwordConfirm.value === '') {
    return null;
  }

  if (password.value === passwordConfirm.value) {
    return null;
  }

  return { passwordsNotMatching: true };
};
